<template>
  <div class="error-trip-wrap">
    <div class="filter-outerblk">
      <div class="single-fieldsouter search-field">
        <v-text-field
          v-model="filter.searchquery"
          label="Crew Name/Crew ID/Cab No/Driver Mobile/Transporter No"
          color="#ff9600"
          outlined
          dense
          hide-details
        ></v-text-field>
      </div>

      <div class="single-fieldsouter" v-if="branchOptions.length > 0">
        <v-autocomplete
          v-model="filter.branch"
          :items="branchOptions"
          label="Station"
          color="#ff9600"
          item-text="name"
          item-value="name"
          outlined
          dense
          hide-details
          clearable
          @change="getTripListing"
        ></v-autocomplete>
      </div>

      <div class="single-fieldsouter">
        <v-autocomplete
          v-model="filter.serviceType"
          placeholder="Responsibility Type"
          label="Responsibility Type"
          item-text="name"
          item-value="id"
          outlined
          dense
          hide-details
          clearable
          color="#09009b"
          :items="serviceTypeList"
          @change="getTripListing"
        ></v-autocomplete>
      </div>

      <div class="single-fieldsouter">
        <v-autocomplete
          v-model="filter.errorType"
          :items="errors"
          label="Error Type"
          clearable
          outlined
          dense
          hide-details
          @change="getTripListing"
        ></v-autocomplete>
      </div>

      <div class="single-fieldsouter">
        <v-menu
          v-model="dateModal"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="filter.date"
              label="Select Date"
              readonly
              v-on="on"
              outlined
              dense
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filter.date"
            color="#d59e1d"
            no-title
            @input="
              dateModal = false;
              getTripListing();
            "
          ></v-date-picker>
        </v-menu>
      </div>

      <div class="reset-outer">
        <v-btn class="lighter-btn" color="#ff9600" @click="getTripListing" text>
          <i class="fas fa-redo"></i>
        </v-btn>
      </div>
      <div class="reset-outer">
        <v-btn class="lighter-btn reset-btn" color="#000" @click="reset">Reset Filter</v-btn>
      </div>
    </div>

    <div class="inner-conte-blk">
      <div class="listing-outerblk">
        <div class="inner-block" id="error-trip-scroll" @scroll="onScroll">
          <div v-if="isLoading" class="loader-outerblk">
            <v-progress-circular :width="5" :size="50" color="red" indeterminate></v-progress-circular>
          </div>
          <ul>
            <li class="data-notavailblk" v-if="trips.length === 0 && !isLoading">No data Available</li>
            <li
              v-for="(trip, index) in trips"
              :key="index"
              @click="selectTrip(trip.id)"
              :class="{ 'active-blk': trip.id === currentTrip }"
            >
              <div class="right-detailsblk">
                <div class="single-field user-name">{{ trip.name || "--" }}</div>
                <div class="single-field phone-number">{{ trip.mobile || "--" }}</div>
                <div class="single-field dat-time">{{ getDate(trip.scheduleDate) }}</div>
                <div class="single-field phone-number">{{ trip.tripType }}</div>
              </div>
            </li>
          </ul>
        </div>
        <div class="pagination-info" v-if="rowCount > 0">
          <span>{{ trips.length }} / {{ rowCount }}</span>
        </div>
      </div>
      <ErrorTripDetails :tripId="currentTrip"></ErrorTripDetails>
    </div>
  </div>
</template>

<script>
import axios from "@/axios/axios-global";
import ErrorTripDetails from "./ErrorTripDetails.vue";
import moment from "moment";

export default {
  name: "ErrorTripList",
  components: { ErrorTripDetails },
  data: () => ({
    filter: {
      searchquery: "",
      branch: null,
      date: moment().format("YYYY-MM-DD"),
      serviceType: null,
      errorType: "",
    },
    isLoading: false,
    trips: [],
    errors: [],
    page: 1,
    nextpage: 1,
    rowCount: 0,
    currentTrip: 0,
    dateModal: false,
    branchOptions: [],
    serviceTypeList: [
      { id: 1, name: "PickUp" },
      { id: 2, name: "DropOff" },
    ],
    searchTimer: null,
  }),
  watch: {
    "filter.searchquery"(val) {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        if (!val || val.length === 0 || val.length >= 3) {
          this.getTripListing();
        }
      }, 400);
    },
  },
  mounted() {
    this.loadBranches();
    this.getTripListing();
  },
  methods: {
    loadBranches() {
      try {
        const stored = localStorage.getItem("branchList");
        const list = stored ? JSON.parse(stored) : [];
        this.branchOptions = Array.isArray(list) ? list : [];
      } catch (e) {
        this.branchOptions = [];
      }
    },
    reset() {
      this.filter = {
        searchquery: "",
        branch: null,
        date: moment().format("YYYY-MM-DD"),
        serviceType: null,
        errorType: "",
      };
      this.page = 1;
      this.nextpage = 1;
      this.trips = [];
      this.currentTrip = 0;
      this.getTripListing();
    },
    async getTripListing() {
      this.isLoading = true;
      this.page = 1;
      this.nextpage = 1;
      try {
        const response = await axios.post("trip/indigo/error/list", {
          page: this.page,
          limit: 25,
          filter: this.filter,
        });
        const data = response.data || {};
        this.trips = data.trips || [];
        this.errors = data.errArray || [];
        this.nextpage = typeof data.nextpage === "number" ? data.nextpage : -1;
        this.rowCount = data.rowCount || 0;
        if (this.trips.length > 0) {
          this.selectTrip(this.trips[0].id);
        } else {
          this.selectTrip(0);
        }
      } catch (e) {
        this.trips = [];
        this.errors = [];
        this.rowCount = 0;
        this.selectTrip(0);
      } finally {
        this.isLoading = false;
      }
    },
    async loadMore() {
      if (this.nextpage === -1 || this.isLoading) return;
      this.isLoading = true;
      try {
        const response = await axios.post("trip/indigo/error/list", {
          page: this.nextpage,
          limit: 25,
          filter: this.filter,
        });
        const data = response.data || {};
        const more = data.trips || [];
        this.trips = this.trips.concat(more);
        this.nextpage = typeof data.nextpage === "number" ? data.nextpage : -1;
        this.rowCount = data.rowCount || this.rowCount;
        if (this.errors.length === 0 && Array.isArray(data.errArray)) {
          this.errors = data.errArray;
        }
      } catch (e) {
        this.nextpage = -1;
      } finally {
        this.isLoading = false;
      }
    },
    onScroll(e) {
      const el = e.target;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 30) {
        this.loadMore();
      }
    },
    selectTrip(id) {
      this.currentTrip = id;
    },
    getDate(date) {
      if (!date) return "--";
      return moment(date).format("MMM DD, YYYY HH:mm");
    },
  },
};
</script>

<style lang="scss" scoped>
.error-trip-wrap {
  padding: 20px;
}

.filter-outerblk {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 0px 5px 0px rgba(106, 7, 75, 0.15);
}

.single-fieldsouter {
  display: flex;
  align-items: center;
  flex: 1 1 200px;
  max-width: 240px;
}

.search-field {
  flex: 1 1 280px;
  max-width: 320px;
}

.reset-outer {
  display: flex;
  align-items: center;
}

.inner-conte-blk {
  display: flex;
  width: 100%;
  margin-top: 20px;
  height: calc(100vh - 260px);
}

.listing-outerblk {
  width: 28%;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 0px 5px 0px rgba(106, 7, 75, 0.15);
  padding: 15px 0;
  position: relative;
  display: flex;
  flex-direction: column;

  .inner-block {
    flex: 1;
    overflow-y: auto;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      padding: 12px 16px;
      border-bottom: 1px solid #e5e5e5;
      cursor: pointer;

      &:hover,
      &.active-blk {
        background: #f1f1f1;
      }

      &.data-notavailblk {
        text-align: center;
        color: #999;
        cursor: default;
        &:hover {
          background: transparent;
        }
      }
    }
  }

  .right-detailsblk {
    .single-field {
      font-family: "Avenir";
      color: #8d8d8d;
      font-size: 14px;

      &.user-name {
        color: #ff9600;
        font-size: 16px;
        font-weight: 500;
      }

      &.phone-number {
        font-size: 14px;
        color: #555;
      }
    }
  }

  .pagination-info {
    text-align: center;
    padding: 8px 0;
    color: #888;
    font-size: 12px;
    border-top: 1px solid #eee;
  }
}

.loader-outerblk {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
</style>
